import * as React from "react"
import parse from "html-react-parser"

import Container from "@components/elements/container"
import SideTitle from "@components/elements/sideTitle"
import Cta from "@components/elements/cta"

import { isSSR } from "@lib/utils"

import styles from "./introTable.module.scss"

const IntroTable = ({ sideTitle, title, items, cta }) => {
  return (
    <section className={styles.introTable}>
      <Container className={styles.container}>
        <SideTitle title={sideTitle} />
        <h2 className={styles.title}>{parse(title)}</h2>

        <div className={styles.table}>
          {items.map(item => (
            <div className={styles.tableItem} key={item.title}>
              <div className={styles.iconContainer}>
                <img
                  className={styles.icon}
                  src={item.icon.publicURL}
                  alt={item.title}
                  loading="lazy"
                />
              </div>
              {item.title && (
                <h3 className={styles.tableItemTitle}>{parse(item.title)}</h3>
              )}
              {item.text && (
                <div className={styles.tableItemText}>{item.text}</div>
              )}

              {item.url && (
                <Cta
                  text="Learn More"
                  url={item.url}
                  className={styles.tableItemCta}
                  variant="textLink"
                  onClick={() => {
                    !isSSR() && window.scroll({ top: 0 })
                  }}
                />
              )}
            </div>
          ))}

          <Cta {...cta} className={styles.buttonCta} />
        </div>
      </Container>
    </section>
  )
}

export default IntroTable
